
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/tag/[slug]",
      function () {
        return require("private-next-pages/articles/tag/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/tag/[slug]"])
      });
    }
  